var React = require('react');

function Dismiss (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.364 5.757L11.56 2.56 9.44.44 6.242 3.635 3.046.44.926 2.56 4.12 5.758.926 8.954l2.12 2.12L6.244 7.88l3.196 3.195 2.12-2.12-3.196-3.198z","fillRule":"nonzero","fill":"#979797"}));
}

Dismiss.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Dismiss;

Dismiss.default = Dismiss;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js!./src/components/NotificationsMenu/components/Notification/dismiss.svg
// module id = 563
// module chunks = 0